import * as React from "react";
const SvgMap = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 25, height: 24, fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#B8C2D3", d: "m3.5 5.89 5-2v14l-5 1.97zM15.16 5.89 9.98 3.55v14.18l5.18 2.72zM21.5 3.89l-5 2.16v13.81l5-1.97z" }));
export default SvgMap;
